export default __webpack_public_path__ + "static/media/m.2f037928.png";